import { render, staticRenderFns } from "./SelectFilterOfTasksModal.vue?vue&type=template&id=61e00884&"
import script from "./SelectFilterOfTasksModal.vue?vue&type=script&lang=js&"
export * from "./SelectFilterOfTasksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports